import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { ID } from "@common/interfaces/id";
import { IID_OL_ESPLETATO_OK_OF } from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIDolEspletatoOkOFState extends EntityState<IID_OL_ESPLETATO_OK_OF, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_OL_ESPLETATO_OK_OF })
@InterfaceDataStore(InterfaceName.ESPLETAMENTO_POSITIVO_OF)
export class IIDolEspletatoOkOFStore extends EntityStore<IIDolEspletatoOkOFState> {
  constructor() {
    super([]);
  }
}
